"use client";

/**
 * App-wide toast host. `toast()` calls from sonner render nothing unless
 * a <Toaster/> is mounted once — this lives in the root layout. Theme
 * follows the next-themes selection so toasts match light/dark.
 *
 * `expand` is ON by default (sonner's default is off, which stacks toasts
 * behind each other as a deck you have to hover to fan out). Concurrent
 * toasts here are usually independent results — a save succeeding while a
 * price alert fires — so hiding all but the newest loses information the
 * user never gets back. Expanded is the hover state made permanent.
 */

import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

export function Toaster(props: ToasterProps) {
  const { theme = "system" } = useTheme();
  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      richColors
      closeButton
      position="bottom-right"
      expand
      visibleToasts={6}
      gap={10}
      {...props}
    />
  );
}
